import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import InvestmentGuideLinks from '../../../components/investmentGuideLinks';

export default () => {
  return (
    <SectionContainer id='guides-to-investing'>
      <Row align='center'>
        <Col medium={8}>
          <Typography
            component='h1'
            nextElement='typography'
            align='center'>
            Guides to Investing at <WidowBlock>Northwestern Mutual</WidowBlock>
          </Typography>
          <Typography
            component='h2'
            nextElement='typography'>
            What You Need to Know
          </Typography>
          <Typography nextElement='typography'>
            Before you consider an investment, it&#39;s important to understand the investment&#8212;and to review your financial situation, including your risk tolerance, time horizon and goals, with your financial advisor.
          </Typography>
          <Typography nextElement='graphic'>
            Below, Northwestern Mutual Investment Services, LLC (&#34;NMIS&#34;) shares information for its clients on a variety of securities&#45;related topics. If you have further questions about the investments and services available through Northwestern Mutual Investment Services, LLC, please contact your Northwestern Mutual Financial Representative.
          </Typography>
        </Col>
      </Row>
      {/* INVESTMENT GUIDE LINKS */}
      <InvestmentGuideLinks />
    </SectionContainer>
  );
};
